import * as React from 'react'
import Menu from '@mui/material/Menu'
import { Drawer, IconButton, Typography } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'

import { Box } from '@mui/system'
import StepperAddUserOrganization from '../../../components/Modals/Organizations/RightModals/AddUserInOrganization'
import StepperEditOrganization from '../../../components/Modals/Organizations/RightModals/UpdateOrganization'
import StepperSeeMoreOrganization from '../../../components/Modals/Organizations/RightModals/SeeMoreOrganization'
import { useState } from 'react'
import StepperAddSuscriber from '../../../components/Modals/Organizations/RightModals/addSuscriber'
import { NavLink } from 'react-router-dom'
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined'

import useStyles from './useStyles'

export default function ModalMenuItem ({ item, setLoading }) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const [stateUserOrganization, setStateUserOrganization] = useState(false)
  const [stateEditorganization, setstateEditOrganization] = useState(false)
  const [stateSeeMore, setstateSeeMore] = useState(false)
  const [stateAddSuscriber, setstateAddSuscriber] = useState(false)
  const classes = useStyles()

  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const list = (anchor) => (
    <Box className={classes.stepperStyleAddUser} role="presentation">
      <StepperAddUserOrganization
        setStateUserOrganization={setStateUserOrganization}
        item={item}
      />
    </Box>
  )

  const listEditOrganization = (anchor) => (
    <Box className={classes.stepperStyle} role="presentation">
      <StepperEditOrganization
        setLoading={setLoading}
        setstateEditrganization={setstateEditOrganization}
        item={item}
      />
    </Box>
  )

  const listSeeMoreOrganization = (anchor) => (
    <Box className={classes.stepperStyleSeeMore} role="presentation">
      <StepperSeeMoreOrganization
        setstateSeeMore={setstateSeeMore}
        item={item}
        setLoading={setLoading}
      />
    </Box>
  )

  const listAddSuscriber = (anchor) => (
    <Box className={classes.stepperStyle} role="presentation">
      <StepperAddSuscriber
        item={item}
        setLoading={setLoading}
        setstateAddSuscriber={setstateAddSuscriber}
      />
    </Box>
  )

  return (
    <>
      <MoreVertIcon
        sx={{
          color: '#026873',
          '&:hover': {
            color: '#00FFAC'
          }
        }}
        onClick={handleClickMenu}
      />

      <Menu
        id="basic-menu"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <FiltersList
          item={item}
          onClose={handleClose}
          setstateSeeMore={setstateSeeMore}
          setstateEditOrganization={setstateEditOrganization}
          setStateUserOrganization={setStateUserOrganization}
          setstateAddSuscriber={setstateAddSuscriber}
        />
      </Menu>
      <Drawer anchor={'right'} open={stateEditorganization}>
        {listEditOrganization('right')}
      </Drawer>
      <Drawer anchor={'right'} open={stateSeeMore}>
        {listSeeMoreOrganization('right')}
      </Drawer>
      <Drawer anchor={'right'} open={stateUserOrganization}>
        {list('right')}
      </Drawer>
      <Drawer anchor={'right'} open={stateAddSuscriber}>
        {listAddSuscriber('right')}
      </Drawer>
    </>
  )
}

function FiltersList ({
  item,
  onClose,
  setstateSeeMore,
  setstateEditOrganization,
  setStateUserOrganization,
  setstateAddSuscriber
}) {
  const classes = useStyles()

  return (
    <Box
      sx={{
        height: 200,
        width: 220
      }}
      className={classes.boxStyle}
    >
      <IconButton
        onClick={() => {
          setstateSeeMore(true)
          onClose()
        }}
      >
        <Box className={classes.boxTypography}>
          <ErrorOutlineOutlinedIcon className={classes.hoverButtonRotate} />
          <Typography className={classes.typographyStyle}>
            Ver detalles
          </Typography>
        </Box>
      </IconButton>

      {/* {isOrganizationTesting(item.organizationType?.organizationTypeCode) &&
        userIsAdministrator() && (
          <>
            <IconButton
              onClick={() => {
                setstateEditOrganization(true)
                onClose()
              }}
            >
              <Box className={classes.boxTypography}>
                <EditIcon className={classes.hoverButton} />

                <Typography className={classes.typographyStyle}>
                  Editar
                </Typography>
              </Box>
            </IconButton>

            <IconButton
              onClick={() => {
                setStateUserOrganization(true)
                onClose()
              }}
            >
              <Box className={classes.boxTypography}>
                <PersonAddOutlinedIcon className={classes.hoverButton} />
                <Typography className={classes.typographyStyle}>
                  Añadir usuario
                </Typography>
              </Box>
            </IconButton>

            <IconButton
              onClick={() => {
                setstateAddSuscriber(true)
                onClose()
              }}
            >
              <Box className={classes.boxTypography}>
                <GroupAddOutlinedIcon className={classes.hoverButton} />
                <Typography className={classes.typographyStyle}>
                  Agregar suscriptor
                </Typography>
              </Box>
            </IconButton>
          </>
      )} */}

      <NavLink
        to={`${item.organizationId}/users`}
        style={{
          textDecoration: 'none'
        }}
      >
        <IconButton>
          <Box className={classes.boxTypography}>
            <PersonOutlineIcon className={classes.hoverButton} />

            <Typography className={classes.typographyStyle}>
              Ver usuarios
            </Typography>
          </Box>
        </IconButton>
      </NavLink>

      <NavLink
        to={`${item.organizationId}/subscribers`}
        style={{ textDecoration: 'none' }}
      >
        <IconButton>
          <Box className={classes.boxTypography}>
            <PeopleOutlineOutlinedIcon className={classes.hoverButton} />

            <Typography className={classes.typographyStyle}>
              Ver suscriptores
            </Typography>
          </Box>
        </IconButton>
      </NavLink>

      <NavLink
        to={`${item.organizationId}/suborganizations`}
        style={{ textDecoration: 'none' }}
      >
        <IconButton>
          <Box className={classes.boxTypography}>
            <ApartmentOutlinedIcon className={classes.hoverButton} />

            <Typography className={classes.typographyStyle}>
              Ver estudios
            </Typography>
          </Box>
        </IconButton>
      </NavLink>

      <NavLink
        to={`/ME/applicationInstances/${item.organizationId}/instance`}
        style={{ textDecoration: 'none' }}
      >
        <IconButton>
          <Box className={classes.boxTypography}>
            <ManageAccountsIcon className={classes.hoverButton} />

            <Typography className={classes.typographyStyle}>
              Ver instancias ME
            </Typography>
          </Box>
        </IconButton>
      </NavLink>
    </Box>
  )
}
